import React from 'react';
import {Footer} from '@unthinkable/react-screen-components';
import {useStyles} from '@unthinkable/react-theme';
import {TableFooterStyles} from './theme';

export const TableFooter = props => {
  const styles = useStyles(TableFooterStyles);
  return <Footer styles={styles} {...props} />;
};
